/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getEnvironmentsOverrides';
import type { GetEnvironmentsQueryParams } from '../../operation-overrides/getEnvironmentsOverrides';

export type GetEnvironmentsPathParams = NonNullable<operations['getEnvironments']['parameters']['path']>;
export type { GetEnvironmentsQueryParams };

export interface Input extends GetEnvironmentsPathParams {
  apiVersion?: string;
  query?: GetEnvironmentsQueryParams;
}

export async function getEnvironments(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/environments', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
